import React from 'react';
import { Button, Card } from '../components/ui';

interface LandingProps {
  onCreateCampaign: () => void;
}

export function Landing({ onCreateCampaign }: LandingProps) {

  return (
    <div
      className="landing-hero"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 'var(--space-6)',
        maxWidth: '900px',
        margin: '0 auto',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: 'var(--space-8)' }}>
        <h1
          className="landing-title"
          style={{
            fontSize: 'var(--text-3xl)',
            fontWeight: 700,
            marginBottom: 'var(--space-3)',
            background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-pink) 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Welcome to Learn by Campaign
        </h1>
        <p
          style={{
            fontSize: 'var(--text-lg)',
            color: 'var(--color-text-secondary)',
            marginBottom: 'var(--space-4)',
          }}
        >
          Dive into interactive text adventures powered by AI as your Game Master
        </p>
      </div>

      <div
        className="landing-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 'var(--space-4)',
          marginBottom: 'var(--space-8)',
          width: '100%',
        }}
      >
        <Card style={{ textAlign: 'center', padding: 'var(--space-6)' }}>
          <div style={{ fontSize: '2rem', marginBottom: 'var(--space-3)' }}>🎭</div>
          <h3 style={{ marginTop: 0 }}>Multiple Genres</h3>
          <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
            D&D fantasy, investigation, sci-fi, horror, and more
          </p>
        </Card>

        <Card style={{ textAlign: 'center', padding: 'var(--space-6)' }}>
          <div style={{ fontSize: '2rem', marginBottom: 'var(--space-3)' }}>🤖</div>
          <h3 style={{ marginTop: 0 }}>AI Game Master</h3>
          <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
            Dynamic storytelling that responds to your choices
          </p>
        </Card>

        <Card style={{ textAlign: 'center', padding: 'var(--space-6)' }}>
          <div style={{ fontSize: '2rem', marginBottom: 'var(--space-3)' }}>📖</div>
          <h3 style={{ marginTop: 0 }}>Your Story</h3>
          <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
            Create up to 3 campaigns and live out unique adventures
          </p>
        </Card>
      </div>

      <Card
        style={{
          padding: 'var(--space-8)',
          textAlign: 'center',
          width: '100%',
          maxWidth: '600px',
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 'var(--space-4)' }}>
          Ready to Begin?
        </h2>
        <p
          style={{
            color: 'var(--color-text-secondary)',
            marginBottom: 'var(--space-6)',
          }}
        >
          Create your first campaign to get started. Choose a genre, pick a template or go random,
          and let the adventure unfold.
        </p>
        <Button onClick={onCreateCampaign} size="lg">
          Create Your First Campaign
        </Button>
      </Card>

      <div style={{ marginTop: 'var(--space-8)', textAlign: 'center' }}>
        <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
          You can create up to 3 campaigns. Ready to dive in?
        </p>
      </div>
    </div>
  );
}
